import type { EditorHost } from '@cbi-blocksuite/block-std';

export class AIDocLogic {
  constructor(private getHost: () => EditorHost) {}

  get host() {
    return this.getHost();
  }
}
